export default __webpack_public_path__ + "static/media/gallery_04.93608086.jpg";